import Control from "sap/ui/core/Control";
import View from "sap/ui/core/mvc/View";

/** Does not work in init method of custom controls */
export function GetController(oControl: Control) {
  let oView = oControl.getParent();

  while (oView && !(oView instanceof View)) {
    oView = oView.getParent();
  }

  return (oView as View).getController();
}
